import ReadMoreComponent from './components/tbeReadMore'
import ReadMoreDirective from './directives/tbeReadMore'

export const createReadMore = () => ({
    install: (app) => {
        app.component('tbeReadMore', ReadMoreComponent)
        app.directive('tbeReadMore', ReadMoreDirective)
    }
})

export default ReadMoreComponent;
